import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ripple-mat-card',
  templateUrl: './ripple-mat-card.component.html',
  styleUrls: ['./ripple-mat-card.component.scss']
})
export class RippleMatCardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
